import React, { useState } from 'react';
import './openEnded.sass';
// import PropTypes from 'prop-types';

const OpenEndedDate = ({ value, onChange, question, user }) => {
  const [inputLength, setInputLength] = useState(0);

  function handleDateChange(event) {
    const dateValue = event.target.value;

    onChange({ value: dateValue, text: dateValue }, question.questionID, question.questionLevel);

    setInputLength(dateValue.length);
  }

  question.questionText = question.questionText.replace(/\{user\}/gi, user);

  return (
    <div className="open-ended-container">
      <h4 className="range-score-question">
        <p className="question-text" dangerouslySetInnerHTML={{ __html: question.questionText }} />
      </h4>

      {question.questionText !== 'You have already completed this survey.' && (
        <>
          <input
            type="date"
            className={`flat-text-area ${question?.error ? 'flat-text-area__error' : ''}`}
            value={value}
            onChange={handleDateChange}
            name="date"
            required
          />

          <div className="input-comment">
            <span style={{ color: 'crimson' }}>
              <strong>{question?.error ? question?.errorMessage : ''}</strong>
            </span>
          </div>
        </>
      )}
    </div>
  );
};

export default OpenEndedDate;
